<template>
  <b-container fluid>
    <b-row>
     <b-col :lg="cols">
        <card>
          <TableActionHeader 
            @filterChange="onFilterChange"
            @newItem="onNewItem"
            :newButton="$UIPrivilegeCreate('system', 'usergroups')">
          </TableActionHeader> 
          <UserGroupTable :filter="filter" @selectItem="onSelectItem"></UserGroupTable>
        </card>
      </b-col>
      <b-col>
        <InfoCard v-if="action == ''"></InfoCard>
        <card v-if="action == 'new'">
           <CardHeader :title="$t('item.new')"/>
             <UserGroupForm :item="item" :action="action" v-on:newItem="onItemUpdated" />
        </card>
        <card v-if="action == 'item' && item">
          <CardHeader :title="item ? item.id + ' - ' + item.description: ''" type="item" />
            <tabs>
              <tab-pane title="tab-1" key="tab-1">
                 <b-icon id="settings" slot="title" icon="gear" scale='1.1'></b-icon>
                  <b-popover target="settings" triggers="hover" placement="top">
                      {{$t("usertable.tooltips.settings")}}
                  </b-popover>
                  <UserGroupForm :item="item" :action="action" />
              </tab-pane>

              <tab-pane title="tab-2" key="tab-2" v-if="$UIPrivilege('system', 'usergroups', 'privileges')">
                <b-icon id="privileges" slot="title" icon="card-list" scale='1.1'></b-icon>
                <b-popover target="privileges" triggers="hover" placement="top">
                      {{$t("usertable.tooltips.privileges")}}
                </b-popover>
                 <TableActionHeader @filterChange="onPrivilegeFilterChange" :newButton="false"/> 
                  <UserGroupPrivilegeTable  :filter="privilegeFilter" :item="item" v-on:updateItem="onItemUpdated" />
              </tab-pane>

               <tab-pane title="tab-3" key="tab-3">
                 <b-icon id="groups" slot="title" icon="person-check" scale='1.1'></b-icon>
                 <b-popover target="groups" triggers="hover" placement="top">
                      {{$t("usertable.tooltips.groups")}}
                 </b-popover>
                 <UserGroupUsers :item="item" />
                </tab-pane>
            </tabs>
          </card>
      </b-col>
     </b-row>
  </b-container>
</template>

<script>

import TableActionHeader from '@/components/Misc/TableActionHeader'
import CardHeader from '@/components/Misc/CardHeader'
import i18n from '@/i18n'

import UserGroupForm from '@/components/System/UserGroupForm'
import UserGroupTable from '@/components/System/UserGroupTable'
import UserGroupPrivilegeTable from '@/components/System/UserGroupPrivilegeTable'
import UserGroupUsers from '@/components/System/UserGroupUsers'

export default {
    components: {
        TableActionHeader, 
        CardHeader, 
        UserGroupForm, 
        UserGroupTable, 
        UserGroupPrivilegeTable,
        UserGroupUsers
    },
    data() {
        return {
            cols: 8,
            filter: null,
            privilegeFilter: null,
            item: {},
            tabIndex: 1,
            action: ""
        }        
    },
    computed: {
        formTitle(){
            return i18n.t('item.' + this.formType);
        }
    },
    methods: {
        onFilterChange: function(filter) {
            this.filter = filter;
        },
        onPrivilegeFilterChange: function(filter) {
            this.privilegeFilter = filter;
        },
        onNewItem: function() {
            this.item = {};        
            this.action = "new"
        },
        onItemUpdated: function(item) {
            this.item = JSON.parse(JSON.stringify(item));                    
            this.action = "item"
            this.$store.dispatch('userDataHandler/getUsers');
        },
        onSelectItem: function(item) { 
            if (item)
                this.item = JSON.parse(JSON.stringify(item));  
            this.action = "item"         
        }
    }


}

</script>
